<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">Thanks go to Russell Galen, my agent, and James Frenkel, my editor; Kelly Frieders, Kali Hale, Helen Keier, Beth Loubet, Cindi Manning, Susan Pinsonneault, Jennifer Quail, Bob and Roxanne Quinlan, and Sean Summers, my Eagle-Eyes, the sharp-sighted folk who diminish the number of errors I introduce into each manuscript; and Steph Chiesi, Jenn Hussong, Derrick K. Johnson, Erin M. Lopez, and Luray Richmond, for offering facts when they were hard to come by.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?05ac694e